const trackID = process.env.REACT_APP_GA_TRACKING_ID ?? '';

export default trackID;
